import {Inject, Injectable} from "@angular/core";
import {TRANSLATIONS} from "./translations"; // import our opaque token
import {CULTURES} from "./cultures";

declare var wijmo;

@Injectable()
export class TranslateService {
  private _currentLang: string;

  public get currentLang() {
    return this._currentLang;
  }

  // inject our translations
  constructor(@Inject(TRANSLATIONS) private _translations: any) {}

  public use(lang: string): void {
    // set current language
    localStorage.setItem("currentLanguage", lang);
    sessionStorage.setItem("currentLanguage", lang);
    this.useCulture(lang);
    this._currentLang = lang;
  }

  numberTranslate(translations, key) {
    const chars = key.split("");
    for (let i = 0; i < chars.length; i++) {
      if (/\d/.test(chars[i])) {
        chars[i] = translations[chars[i]];
      }
    }
    return chars.join("");
  }

  private translate(key: any, type?: string) {
    const translation = key;
    if (type) {
      if (type === "number") {
        if (this._translations[this.currentLang]) {
          return this.numberTranslate(
            this._translations[this.currentLang],
            key
          );
        }
        // const numberKey = key.toString();
        // let numberTranslate = '';
        // if (numberKey.includes('.')) {
        //   const numberKeySplit = numberKey.split('.');
        //   for (let i = 0; i < numberKeySplit[0].length; i++) {
        //     if (this._translations[this.currentLang] && this._translations[this.currentLang][numberKeySplit[0][i]]) {
        //       numberTranslate = numberTranslate + this._translations[this.currentLang][numberKeySplit[0][i]];
        //     }
        //   }
        //   numberTranslate = numberTranslate + wijmo.culture.Globalize.numberFormat['.'] + numberKeySplit[1];
        // } else {
        //   for (let i = 0; i < numberKey.length; i++) {
        //     if (this._translations[this.currentLang] && this._translations[this.currentLang][numberKey[i]]) {
        //       numberTranslate = numberTranslate + this._translations[this.currentLang][numberKey[i]];
        //     }
        //   }
        // }
        // return numberTranslate.length > 0 ? numberTranslate : key;
      }
    } else {
      if (
        this._translations[this.currentLang] &&
        this._translations[this.currentLang][key]
      ) {
        return this._translations[this.currentLang][key];
      }
    }
    return translation;
  }

  public useCulture(lang): void {
    localStorage.setItem("currentCulture", CULTURES[lang]);
    sessionStorage.setItem("currentCulture", CULTURES[lang]);
  }

  public instant(key: string, type?: string) {
    return this.translate(key, type);
  }

  public backInstant(key: string, type?: string) {
    return this.backTranslate(key, type);
  }

  private backTranslate(value: any, type?: string) {
    const translation = value;
    if (type) {
      if (type === "number") {
        if (this._translations[this.currentLang]) {
          // return this.numberTranslate(this._translations[this.currentLang], key);
        }
      }
    } else {
      if (!this.currentLang) {
        this.use(localStorage.getItem("current_language") ?? "tr");
      }
      if (this._translations[this.currentLang]) {
        return Object.keys(this._translations[this.currentLang]).find(
          (key) => this._translations[this.currentLang][key] === value
        );
      }
    }
    return translation;
  }
}
